var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GradingAnswer } from '@digabi/exam-engine-core';
import classNames from 'classnames';
import React, { memo, useContext } from 'react';
import { postJson } from '../common/utils';
import { isEmptyAnswer } from './types';
import { GradingUrlsContext } from './grading-view';
import { useTranslation } from 'react-i18next';
export default memo(Answer);
function Answer(props) {
    var _a, _b, _c, _d;
    const { innerRef, answer, gradingRole, setLocalizedError, setExamAndScores, AnswerCommentElement, canBeAnnotated, showPregradingAnnotations } = props;
    const gradingUrls = useContext(GradingUrlsContext);
    const { i18n } = useTranslation();
    return (React.createElement("div", { ref: innerRef, tabIndex: 1, id: "answer-wrap", className: classNames('e-exam', { 'hide-pregrading-annotations': !showPregradingAnnotations }) },
        React.createElement(GradingAnswer, { answer: answer.content, language: `${i18n.language}-FI`, isReadOnly: !canBeAnnotated, gradingRole: gradingRole, annotations: {
                pregrading: showPregradingAnnotations ? ((_b = (_a = answer.pregrading) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.annotations) || [] : [],
                censoring: ((_d = (_c = answer.censoring) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.annotations) || []
            }, maxLength: answer.maxLength, saveAnnotations: saveAnnotations, popupTopMargin: 0 }),
        AnswerCommentElement));
    function filterInvalidAnnotations(annotations) {
        return annotations.filter(annotation => 'startIndex' in annotation || 'attachmentIndex' in annotation);
    }
    function saveAnnotations(annotations) {
        const updateAnnotations = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield postJson(gradingUrls.postAnnotation(gradingRole, answer.answerId), {
                metadata: { annotations: filterInvalidAnnotations(annotations[gradingRole]) }
            });
            if (response.status >= 400) {
                setLocalizedError({ localizeKey: 'arpa.errors.saving_metadata_failed' });
            }
            else {
                setExamAndScores(previousState => {
                    if (!previousState)
                        return previousState;
                    return Object.assign(Object.assign({}, previousState), { students: previousState.students.map(student => (Object.assign(Object.assign({}, student), { answers: student.answers.map(a => {
                                if (!isEmptyAnswer(a) && a.answerId === answer.answerId && a[gradingRole]) {
                                    return Object.assign(Object.assign({}, a), { [gradingRole]: Object.assign(Object.assign({}, a[gradingRole]), { metadata: { annotations: filterInvalidAnnotations(annotations[gradingRole]) } }) });
                                }
                                return Object.assign({}, a);
                            }) }))) });
                });
            }
        });
        updateAnnotations().catch(() => {
            setLocalizedError({ localizeKey: 'arpa.errors.saving_metadata_failed' });
        });
    }
}
//# sourceMappingURL=answer.js.map